<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  <title>Rent2End sygnet</title>
  <circle class="sygnet path-primary" cx="50" cy="50" r="48" fill="#d8376f"></circle>
  <path class="sygnet path-inverse-surface"
        d="M 74 69.5 L 74 38.5 L 50 20 L 26 38.5 L 26 72 L 64 72 L 64 44 L 50 33 L 36 44 L 36 61 L 55 61"
        stroke="#efedf0"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round" />
</svg>